import { createSelector } from '@reduxjs/toolkit';
import { pick } from 'lodash';
import { AppState } from '../modules';

export const selectSessionSettings = createSelector(
  (state: AppState) => state.settings,
  (settings) => settings.session,
);

export const selectPartialSessionSettings = <T extends string[]>(...keys: T) =>
  createSelector(
    selectSessionSettings,
    (settings) =>
      (keys.length > 0 ? pick(settings, keys) : settings) as {
        [K in T[number]]: unknown;
      },
  );

export const selectSessionSetting = <T = string>(key: string) =>
  createSelector(selectSessionSettings, (settings) => settings[key] as T);

export const selectFeatureFlag = (key: string) =>
  createSelector(selectSessionSettings, (settings) => {
    const CONFIRMED_FEATURES = ['states'];

    if (CONFIRMED_FEATURES.includes(key)) {
      return true;
    }

    return !!settings[`features.experimental.${key}`];
  });

export const selectProjectSettings = createSelector(
  (state: AppState) => state.settings,
  (settings) => settings.project,
);

export const selectPreferences = createSelector(
  (state: AppState) => state.settings,
  (settings) => settings,
);

export const selectServerSettings = createSelector(
  (state: AppState) => state.settings,
  (settings) => settings.server,
);

export const selectRemoteDebuggerMode = createSelector(
  selectServerSettings,
  (app) => app.remoteDebuggerMode,
);

export const selectQodly = createSelector(
  selectServerSettings,
  (app) => app.qodly,
);

export const selectMonacoZoom = createSelector(
  selectSessionSettings,
  (settings) => settings['monaco.zoom'],
);
